import script from "./GroupActionConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupActionConfig.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__